/**
 * Ekranın takip ettiği toplu işler (ilerleme kutusu). Tarayıcıda saklanır; sayfa değişse ya da
 * yenilense de kutu kaldığı yerden devam eder. Tarayıcı depolaması kapalıysa yalnız bu oturumda tutulur.
 */
export interface TrackedBatch {
    batchId: string
    companyId: string | null
    title: string
    addedAt: number
}

const KEY = 'jobQueueTrackedBatches'
export const JOB_QUEUE_CHANGED_EVENT = 'jobqueue:changed'
export const JOB_QUEUE_BATCH_COMPLETED_EVENT = 'jobqueue:batchcompleted'

let memory: TrackedBatch[] = []

const read = (): TrackedBatch[] => {
    try {
        const s = localStorage.getItem(KEY)
        return s ? JSON.parse(s) : memory
    } catch {
        return memory
    }
}

const write = (list: TrackedBatch[]) => {
    memory = list

    try { localStorage.setItem(KEY, JSON.stringify(list)) } catch { }

    window.dispatchEvent(new Event(JOB_QUEUE_CHANGED_EVENT))
}

const currentCompanyId = (): string | null => {
    try { return localStorage.getItem('SelectedCompanyId') } catch { return null }
}

export const jobQueueTracker = {
    /** Yalnız seçili firmanın işleri (başka firmaya geçilince kutu o firmanınkini gösterir). */
    list: (): TrackedBatch[] => read().filter(x => x.companyId == currentCompanyId()),

    add: (batchId: string, title: string) => {
        // Bir günden eski takipler temizlenir.
        const limit = Date.now() - 24 * 60 * 60 * 1000
        write([...read().filter(x => x.addedAt > limit && x.batchId != batchId), { batchId, title, companyId: currentCompanyId(), addedAt: Date.now() }])
    },

    remove: (batchId: string) => write(read().filter(x => x.batchId != batchId)),
}
